module.exports = __webpack_public_path__ + "static/media/ck.e697f1d6.svg";